// localStorage

export const ORDER__CACHE__KEY = "ORDER__CACHE";


// Cookie 

export const USER__CASHE__KEY ="USER__CASH";